var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("input", {
    directives: [
      {
        name: "model",
        rawName: "v-model",
        value: _vm.currentValue,
        expression: "currentValue"
      }
    ],
    staticClass: "h-4",
    class: [_vm.disabled ? "is-disabled" : "", "h-4", "fs-3"],
    attrs: {
      disabled: _vm.disabled,
      placeholder: _vm.placeholder,
      type: "text"
    },
    domProps: { value: _vm.currentValue },
    on: {
      keydown: _vm.onKeydown,
      blur: _vm.validate,
      input: function($event) {
        if ($event.target.composing) {
          return
        }
        _vm.currentValue = $event.target.value
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }